import type {
  TerminalMessageListener,
  TerminalStatusListener,
  TerminalUnsubscribe,
} from './types';

export interface TerminalListeners<T> {
  subscribe: (listener: (value: T) => void) => TerminalUnsubscribe;
  emit: (value: T) => void;
  clear: () => void;
}

export function createListeners<T>(): TerminalListeners<T> {
  const listeners = new Set<(value: T) => void>();
  return {
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    emit: (value) => {
      for (const listener of [...listeners]) {
        listener(value);
      }
    },
    clear: () => listeners.clear(),
  };
}

export type MessageListeners = TerminalListeners<
  Parameters<TerminalMessageListener>[0]
>;
export type StatusListeners = TerminalListeners<
  Parameters<TerminalStatusListener>[0]
>;
